import { api } from "@/utility/axios";
import { BookModel } from "@/types";
import { apiConfig } from "@/configs/appConfig";
import { get, set } from "@/data/ionicStorage";

export const SmartBookService = {
  getBookById: async (bookId: number): Promise<BookModel> => {
    try {
      const bookData: BookModel = (await get(`book-${bookId}`)) as BookModel;
      if (bookData) {
        return bookData;
      } else {
        const response = await api.get<BookModel>(apiConfig.downloadBook, {
          params: {
            bookId: bookId,
            includePageItems: true,
            includePageImages: false,
            includeGfImages: false,
          },
        });
        if (response.data) {
          await set(`book-${bookId}`, response.data);
          return response.data;
        } else {
          return response.data;
        }
      }
    } catch (ex) {
      return Promise.reject(ex);
    }
  },
};
